<template>
<div v-if="!this.katudo.id" id="content">
	<div class="content-blk">
		<p class="center">エラーが発生しました。</p>
		<div class="center">
			<router-link to="/"><button class="btn_on">検索画面へ戻る</button></router-link>
		</div>
	</div>
</div>
<div v-else id="content">
<!-- ページ内ヘッダ -->
	<!-- <div class="center">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>はじめに</li>
			<li>基本情報</li>
			<li>連絡先</li>
			<li>その他</li>
			<li>内容確認</li>
			<li class="selected">申込完了</li>
		</ul>
	</div> -->
	<div class="inner">
		<!-- 内容 -->
		<div id="mosikomi" class="content-blk">
				<!-- ステップ5：完了画面 -->
				<p class="Regist_title">登録が完了しました</p>
				<p class="center">メールアドレスを登録された方へ受付完了メールを送信しました<br>
					メールが届いていない方は、青森市社会福祉協議会へお問合せください。<br>
					<span class="error" style="font-size: 1.6rem;">※ブラウザの戻るボタンは使用しないでください。</span></p>
				<div class="point_box">
					<span class="box-title">POINT</span>
					<div class="point_detail">
						<div>
							<fa icon="exclamation-circle" class="icon fa-fw" /><span class="point_title">登録内容は後から確認できません</span>
						</div>
						<div>
							<p class="point_text">PDF・スクリーンショット等で保存してください。</p>
						</div>
						<div>
							<div class="point_text btn_download" @click="print"><fa icon="download" class="icon far fa-angle-double-down fa-fw" />印刷・PDF出力</div>
						</div>
					</div>
					<div v-if="this.katudo.age < 18" class="point_detail">
					<!-- <div class="point_detail"> -->
						<div class="warn_red">
							<fa icon="exclamation-circle" class="icon fa-fw" /><span class="point_title">18歳未満の方へ</span>
						</div>
						<div>
							<p class="point_text warn_red">18歳未満の方は同意書が必要となります。<!-- 文章は同意書の運用確定後に修正する予定 同意書をダウンロードし、必要事項を記入、又は、入力してから郵送でお送り下さい。取得した「ID」は、同意書確認後に利用可能となりますので、ご了承下さい。-->
							</p>
						</div>
						<div class="point_text btn_download">
							<a href="/pdf/Doui.pdf" download="Doui.pdf" target="_blank">
							<span><fa icon="download" class="icon far fa-angle-double-down fa-fw" />同意書ダウンロード</span></a>
						</div>
					</div>
				</div>
			<div class="inner">
				<!-- 表形式にしてもいい？ -->
				<table class="table_confirm">
					<tr>
						<td width="40%">ログインID</td>
						<td width="60%">{{ katudo.id }}</td>
					</tr>
					<tr>
						<td>パスワード</td>
						<td>{{ katudo.password }}</td>
					</tr>
					<tr>
						<td>氏名</td>
						<td>{{ katudo.name }}</td>
					</tr>
					<tr>
						<td>ふりがな</td>
						<td>{{ katudo.kana }}</td>
					</tr>
					<tr>
						<td>性別</td>
						<td v-if="katudo.sex === '2'">男性</td><td v-else-if="katudo.sex === '1'">女性</td>
					</tr>
					<tr>
						<td>生年月日</td>
						<td>{{ katudo.birthday }}</td>
					</tr>
					<tr>
						<td>郵便番号</td>
						<td>〒{{ katudo.zipcode1 }}-{{ katudo.zipcode2 }}</td>
					</tr>
					<tr>
						<td>住所</td>
						<td>{{ katudo.address }}</td>
					</tr>
					<tr>
						<td>電話番号</td>
						<td>{{ katudo.tel }}</td>
					</tr>
					<tr>
						<td>FAX番号</td>
						<td>{{ katudo.fax }}</td>
					</tr>
					<tr>
						<td>携帯電話番号</td>
						<td>{{ katudo.phone }}</td>
					</tr>
					<tr>
						<td>メールアドレス</td>
						<td>{{ katudo.mail }}</td>
					</tr>
					<tr>
						<td>職業</td>
						<td v-if="katudo.job === '1'">社会人</td><td v-else-if="katudo.job === '2'">主婦/主夫</td><td v-else-if="katudo.job === '3'">学生</td><td v-else-if="katudo.job === '4'">フリーター</td><td v-else-if="katudo.job === '5'">無職</td>
					</tr>
					<tr v-if="katudo.company">
						<td>勤務先・学校名</td>
						<td>{{ katudo.company }}</td>
					</tr>
					<tr>
						<td>ボランティア活動経験</td>
						<td v-if="katudo.keiken === '1'">有り</td><td v-else-if="katudo.keiken === '2'">無し</td>
					</tr>
				</table>
			</div>

			<div class="center">
				<!-- <button class="btn_off" @click="print">PDFで保存</button> -->
				<router-link to="/"><button class="btn_on">検索画面へ戻る</button></router-link>
			</div>

		</div>
	</div>
</div>
</template>

<script>
// 状態管理
import { inject } from 'vue';
// import router from '../router';
export default {
	name: 'KatsudoTouroku5',
	components: {
	},
	setup(){
		const { katudo, birthtoDay, calcYear } = inject('ktouroku');
		// const { login, autoLogin } = inject('loginstate');
		return {
			katudo,
			birthtoDay,
			calcYear,
			// login,
			// autoLogin
		};
	},
	data() {
		return {
			// katudo: {},
		};
	},
	async created(){
		this.birthtoDay();
		this.calcYear();

		// this.login.loginid = this.katudo.loginid;
		// this.login.password = this.katudo.password;
		// setTimeout(this.autoLogin(),2000)
	},
	methods: {
		print() {
			// 登録処理（追記）
			window.print();
		},
	},
}
</script>

